import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=f65813b8&"
var script = {}
import style0 from "./Impressum.vue?vue&type=style&index=0&id=f65813b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports